import { Loader2Icon, type LucideProps } from 'lucide-react';

import { cn } from '../lib/utils/cn';

function Spinner({ className, ...props }: LucideProps) {
  return (
    <Loader2Icon
      aria-label="Loading"
      className={cn('text-muted-foreground size-6 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
